import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import {
  DEFAULT_LANGUAGE,
  FALLBACK_LANGUAGE,
  INITIAL_NAMESPACES,
  SUPPORTED_LANGUAGES,
  applyDocumentLanguage,
  getInitialLanguage,
  normalizeLanguage,
  persistLanguage,
} from "./config";

const translationModules = import.meta.glob("./locales/*/*.json");

const lazyJsonBackend = {
  type: "backend",
  read(language, namespace, callback) {
    const normalizedLanguage = normalizeLanguage(language);
    const moduleKey = `./locales/${normalizedLanguage}/${namespace}.json`;
    const fallbackModuleKey = `./locales/${FALLBACK_LANGUAGE}/${namespace}.json`;
    const loader = translationModules[moduleKey] || translationModules[fallbackModuleKey];

    if (!loader) {
      callback(null, {});
      return;
    }

    loader()
      .then((module) => {
        callback(null, module.default || module);
      })
      .catch((error) => {
        callback(error, false);
      });
  },
};

const initialLanguage = getInitialLanguage();
applyDocumentLanguage(initialLanguage);
persistLanguage(initialLanguage);

i18n
  .use(lazyJsonBackend)
  .use(initReactI18next)
  .init({
    lng: initialLanguage,
    fallbackLng: FALLBACK_LANGUAGE,
    supportedLngs: Object.keys(SUPPORTED_LANGUAGES),
    nonExplicitSupportedLngs: false,
    load: "languageOnly",
    ns: INITIAL_NAMESPACES,
    defaultNS: "common",
    fallbackNS: "common",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    returnNull: false,
  });

i18n.on("languageChanged", (language) => {
  const normalizedLanguage = normalizeLanguage(language || DEFAULT_LANGUAGE);
  persistLanguage(normalizedLanguage);
  applyDocumentLanguage(normalizedLanguage);
});

export default i18n;
